import {
  POST_CANCEL_HAND,
  POST_PRE_INVESTIGATE,
  POST_PRE_INVESTIGATE_CANCEL_HAND,
} from "../../../API/apiUrls";

// constants.js
export const OPTIONS_TIME = [
  { value: 0, label: "ทั้งหมด" },
  { value: 30, label: "เคยสืบแล้วเมื่อ 1 เดือน" },
  { value: 90, label: "เคยสืบแล้วเมื่อ 3 เดือน" },
  { value: 120, label: "เคยสืบแล้วเมื่อ 4 เดือน" },
  { value: 180, label: "เคยสืบแล้วเมื่อ 6 เดือน" },
];

export const OPTIONS_TYPE = [
  { value: "lsfhp", label: "จำนอง สัญญา 1" },
  { value: "vsfhp", label: "เช่าซื้อบัญชี 2" },
  { value: "sfhp", label: "เช่าซื้อบัญชี 8" },
  { value: "rpsl", label: "P-LOAN" },
];

export const OPTIONS_STATUS = [
  { value: 0, label: "ยังไม่เคยสืบทรัพย์" },
  { value: 1, label: "แจ้งส่งสืบทรัพย์" },
  { value: 2, label: "ดำเนินการส่งสืบทรัพย์" },
  { value: 3, label: "เจอทรัพย์" },
  { value: 4, label: "ไม่เจอทรัพย์" },
];

export const OPTION_CONTRACT_PERIOD = [
  { value: "120", label: "ยอดน้อยกว่า 20% ขาดติดต่อ 120 วัน " },
  {
    value: "180",
    label: "เกรด D ขึ้นไป ยอดมากกว่า 20% ขาดติดต่อ 180 วัน ",
  },
  { value: "240", label: "เกรด D ขึ้นไป ขาดติดต่อ 240 วัน " },
];

export const BASE_OPTIONS = [
  { value: 0, label: "ทั้งหมด" },
  { value: 1, label: "พร้อมฟ้อง" },
  { value: 2, label: "เจอทรัพย์" },
  { value: 3, label: "ไม่เจอทรัพย์" },
  { value: 4, label: "ออกบอกเลิกแล้ว" },
  { value: 5, label: "ไม่มีบอกเลิก" },
  { value: 8, label: "ตอบกลับบางส่วน" },
  { value: 9, label: "ตอบกลับครบ" },
  { value: 6, label: "ยังไม่สืบ" },
  { value: 7, label: "ดำเนินการส่งสืบทรัพย์" },
];

export const EXCLUSIONS = {
  1: [0, 4, 5, 6, 7, 8],
  2: [6, 7],
  4: [5],
  5: [4, 1, 8, 9],
  6: [7, 2, 1],
  7: [6, 2, 1],
  8: [9, 5, 4],
  9: [8, 5, 4],
};

export const BTN_TO_API = {
  1: POST_PRE_INVESTIGATE,
  2: POST_CANCEL_HAND,
  3: POST_PRE_INVESTIGATE_CANCEL_HAND,
};
